import { useCallback, useState } from "react";
import type { ZodSchema } from "zod";

/**
 * Provided a zod schema and value, returns an error message if field has been blurred and it's invalid.
 * An `onBlur` handler is meant to be applied to the relevant input field
 */
export const useOnBlurError = (schema: ZodSchema, value: string) => {
    const [hasBlurred, setHasBlurred] = useState(false);

    const onBlur = useCallback(() => {
        setHasBlurred(true);
    }, []);

    const { success, error } = schema.safeParse(value);

    return {
        message: !success && hasBlurred ? error.errors[0].message : "",
        isValid: success,
        onBlur,
    };
};
